export { default as incomeGeneralImg } from './income-general.svg';
export { default as incomeRelevanceImg } from './income-relevance.svg';
export { default as incomeEaseImg } from './income-ease.svg';
export { default as addressEaseImg } from './address-ease.svg';
export { default as addressRelevanceImg } from './address-relevance.svg';
export { default as nameEaseImg } from './name-ease.svg';

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/components/SocialProof/SocialProof.scss');